import React, { useCallback, useContext, useEffect, useMemo, useState } from "react"
import { Children } from "../../../../components/miscellianous/children"
import { BSBuildingContext } from "../../../../pages/projects/project/beem-shot/variant/building/components/context/BSBuildingContext"
import { BSBuildingResult } from "../../../dto/beem-shot/BSBuildingResult/BSBuildingResult"
import { useBSDashboard } from "../../../hooks/beem-shot/useBSDashboard"

export const BSBuildingResultContext = React.createContext<BSBuildingResultStore>({} as BSBuildingResultStore)

export function BSBuildingResultContextProvider({ children }: Readonly<Children>): React.JSX.Element {
  const { selectedBSBuilding } = useContext(BSBuildingContext)
  const { getBSBuildingResult } = useBSDashboard()
  const [bsBuildingResult, setBSBuildingResult] = useState<BSBuildingResult | undefined>(undefined)

  const refreshBuildingResult: () => Promise<void> = useCallback(() => {
    if (selectedBSBuilding?.id) {
      return getBSBuildingResult(selectedBSBuilding?.id).then((response) => {
        setBSBuildingResult(response)
      })
    } else {
      setBSBuildingResult(undefined)
      return Promise.resolve()
    }
  }, [getBSBuildingResult, selectedBSBuilding])

  useEffect(() => {
    refreshBuildingResult()
  }, [refreshBuildingResult])

  const bsBuildingResultStore = useMemo(
    () => ({
      bsBuildingResult,
      refreshBuildingResult,
    }),
    [bsBuildingResult, refreshBuildingResult]
  )
  return <BSBuildingResultContext.Provider value={bsBuildingResultStore}>{children}</BSBuildingResultContext.Provider>
}

export interface BSBuildingResultStore {
  bsBuildingResult: BSBuildingResult | undefined
  refreshBuildingResult(): Promise<void>
}
